import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import LoginPage from './LoginPage';
import ApplicationListPage from './ApplicationListPage';
// import BookingGuidelinesView from './ApplicationPage/BookingGuidelinesView';
import BookingApplication from './ApplicationPage/BookingApplication';
// import BookingDetailsView from './ApplicationPage/BookingDetailsView';

import FavoriteDestinationListPage from './FavoriteDestinationListPage';

export default history =>
	combineReducers({
		router: connectRouter(history),
		loginPageReducer: LoginPage,
		applicationListPageReducer: ApplicationListPage,
		applicationDetailPage: combineReducers({
			applicationBasicPageReducer: BookingApplication
		}),
		favoriteDestinationListPageReducer: FavoriteDestinationListPage
	});
